import { Button } from '@nexelem/components';
import { createModal, StaticModal } from '@nexelem/modals';
import { useCustomTranslation } from '../../../../../hooks';
import {
  HistoricalParallelMachinePairsMatrixModalContent,
  HistoricalParallelMachinePairsMatrixModalContentProps,
} from './HistoricalParallelMachinePairsMatrixModalContent';

const HistoricalParallelMachinePairsMatrixModal = (props: HistoricalParallelMachinePairsMatrixModalContentProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');

  return (
    <StaticModal fullScreen onClose={closeHistoricalParallelMachinePairsMatrixModal}>
      <StaticModal.Header withCloseButton>{tWrapper('policy.parallelPairs.matrixTitle')}</StaticModal.Header>
      <StaticModal.Content className="flex min-h-0 flex-1 flex-col gap-4">
        <p className="shrink-0 text-s16 text-text-secondary">{tWrapper('policy.parallelPairs.matrixLegend')}</p>
        <HistoricalParallelMachinePairsMatrixModalContent {...props} />
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={closeHistoricalParallelMachinePairsMatrixModal}>
          {tWrapper('policy.parallelPairs.closeMatrix')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openHistoricalParallelMachinePairsMatrixModal, closeHistoricalParallelMachinePairsMatrixModal } =
  createModal(HistoricalParallelMachinePairsMatrixModal, {
    name: 'HistoricalParallelMachinePairsMatrixModal',
  });
